var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIzi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99232 22.26L19.2547 8.91992L23.9166 15.6783L19.1888 22.439H10.0865C10.0659 22.4386 10.0457 22.4327 10.0281 22.4218C10.0105 22.411 9.99612 22.3956 9.98649 22.3773C9.97686 22.359 9.97232 22.3385 9.97335 22.3179C9.97437 22.2972 9.98093 22.2772 9.99232 22.26V22.26Z",
    fill: "#7E49FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8384 22.26L28.576 8.91992L23.9165 15.6783L28.6419 22.439H37.7442C37.7648 22.4386 37.785 22.4327 37.8026 22.4218C37.8202 22.411 37.8346 22.3956 37.8442 22.3773C37.8538 22.359 37.8584 22.3385 37.8574 22.3179C37.8563 22.2972 37.8498 22.2772 37.8384 22.26V22.26Z",
    fill: "#7E49FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9987 24.187C38.0228 26.0518 37.6764 27.9028 36.9795 29.6326C36.2825 31.3624 35.249 32.9365 33.9389 34.2637C32.6287 35.5909 31.068 36.6447 29.3474 37.364C27.6267 38.0832 25.7804 38.4536 23.9155 38.4536C22.0506 38.4536 20.2042 38.0832 18.4836 37.364C16.7629 36.6447 15.2022 35.5909 13.8921 34.2637C12.582 32.9365 11.5484 31.3624 10.8515 29.6326C10.1546 27.9028 9.80811 26.0518 9.83223 24.187H18.7837C18.7691 24.8696 18.8909 25.5482 19.142 26.183C19.393 26.8179 19.7684 27.3962 20.2459 27.8841C20.7234 28.372 21.2936 28.7596 21.9229 29.0242C22.5522 29.2888 23.2281 29.4252 23.9108 29.4252C24.5935 29.4252 25.2693 29.2888 25.8986 29.0242C26.5279 28.7596 27.0981 28.372 27.5756 27.8841C28.0532 27.3962 28.4285 26.8179 28.6796 26.183C28.9307 25.5482 29.0525 24.8696 29.0378 24.187H37.9987Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzi);
export default __webpack_public_path__ + "static/media/izi.1bac3275559a29dee3dcf3286bfed427.svg";
export { ForwardRef as ReactComponent };